import { render, staticRenderFns } from "./Input_TextArea.vue?vue&type=template&id=0aed9e32"
import script from "./Input_TextArea.vue?vue&type=script&lang=js"
export * from "./Input_TextArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports